module.exports = __webpack_public_path__ + "static/media/DSC_0374.4dc0d77f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0374.jpg
// module id = 579
// module chunks = 0